export default {
  SET_LIST: 'setList',
  SET_QUEUE: 'setQueue',
  SET_FLAG_TO_QUEUE_ITEM: 'setFlagToQueueItem',
  SET_UPLOADED_ITEMS: 'setUploadedItems',
  ADD_TIME_OUT_TOKEN: 'addTimeOutToken',
  CLEAR_TIME_OUT_TOKENS: 'clearTimeOutTokens',
};
